export default __webpack_public_path__ + "static/media/branches.c3d6f263.png";